import React, { useState } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Modal,
} from '@lockerpm/design';

import {
} from "@ant-design/icons";

import formsComponents from "../../../../../components/forms";

import userServices from '../../../../../services/user';
import authServices from '../../../../../services/auth';

import global from "../../../../../config/global";

const ChangeMasterPasswordModal = (props) => {
  const { ChangePasswordForm } = formsComponents;
  const { t } = useTranslation()
  const {
    visible = false,
    currentPassword,
    onClose = () => { },
  } = props;
  
  const userInfo = useSelector((state) => state.auth.userInfo);
  const [callingAPI, setCallingAPI] = useState(false);

  const handleSave = async (values) => {
    setCallingAPI(true);
    await userServices.change_master_password({
      username: userInfo.email,
      password: currentPassword,
      password_hint: values.password_hint,
      login_method: 'password',
      kdf: userInfo.kdf,
      kdf_iterations: userInfo.kdf_iterations,
      kdf_memory: userInfo.kdf_memory,
      kdf_parallelism: userInfo.kdf_parallelism
    }, {
      password: values.new_password,
      kdf: userInfo.kdf,
      kdf_iterations: userInfo.kdf_iterations,
      kdf_memory: userInfo.kdf_memory,
      kdf_parallelism: userInfo.kdf_parallelism
    }).then(async () => {
      global.pushSuccess(t('notification.success.change_master_password.changed'));
      onClose();
      authServices.logout();
    }).catch((error) => {
      global.pushError(error)
    })
    setCallingAPI(false);
  }

  return (
    <Modal
      title={t('change_password.title')}
      open={visible}
      onCancel={onClose}
      width={360}
      footer={false}
    >
      <p className="mb-4">{t('change_password.description')}</p>
      <ChangePasswordForm
        changing={callingAPI}
        onSave={(values) => handleSave(values)}
      />
    </Modal>
  );
}

export default ChangeMasterPasswordModal;